import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { UnreadMessageMarker, UnreadMessageMarkerLine } from './styles';

export const NewMessagesMarker: FC = () => {
  return (
    <UnreadMessageMarker>
      <UnreadMessageMarkerLine />
      <p>
        <FormattedMessage id="projects.conversations.new_messages" />
      </p>
      <UnreadMessageMarkerLine block />
    </UnreadMessageMarker>
  );
};
